import React from "react";
import "./tab-container.scss";
import SingleTab, { SingleTabProps } from "./single-tab";

interface TabContainerProps {
  tabsDetails: SingleTabProps[];
  tabContainerId: string;
  currentActiveTabIndex?: (index: number) => void;
}

export function TabContainer(props: TabContainerProps) {
  const [currentIndex, setCurrentIndex] = React.useState<number>(0);

  React.useEffect(() => {
    if (currentIndex >= props.tabsDetails.length) {
      setCurrentIndex(0);
    }
  }, [props.tabsDetails, currentIndex]);

  const currentTab = props.tabsDetails[currentIndex];

  return (
    <div className="custom-tab-container" id={props.tabContainerId}>
      <div className="tab-headers">
        {props.tabsDetails.map((tab, index) => (
          <div
            key={tab.id}
            onClick={() => {
              setCurrentIndex(index);
              props?.currentActiveTabIndex?.(index);
            }}
          >
            <SingleTab
              id={tab.id}
              label={tab.label}
              currentActiveTab={currentTab?.id}
            />
          </div>
        ))}
      </div>
      <div className="tabs-outlet">
        {React.createElement(currentTab?.tabContent ?? "")}
      </div>
    </div>
  );
}
